import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as fileUtils from 'app/lib/fileUtils';
import { setMembers } from '../actions';
import CsvUtils from '../utils/CsvUtils';

export class CsvFileChooserUnconnected extends Component {
  constructor(props) {
    super(props);

    this.fileChanged = this.fileChanged.bind(this);
    this.parseCsv = this.parseCsv.bind(this);
    this.state = { errors: [] };
  }

  fileChanged(e) {
    const file = e.target.files[0];
    fileUtils.readTextFile(file, this.parseCsv);
  }

  isAscii(str) {
    return /^[\x00-\x7F]*$/.test(str);
  }

  parseCsv(fileContents) {
    if (!this.isAscii(fileContents)) {
      const error = { line: 0, message: 'Please make sure the file is in CSV format' };
      this.setState({ errors: [error] });
      return;
    }
    const lines   = fileContents.split(/[\r\n]+/g);
    const input   = lines.map(line => line.trim().split(/\s*,\s*/));
    const members = CsvUtils.cleanup(input);
    const errors  = CsvUtils.validate(members);
    const hasErrors = errors.length > 0;
    const actualMembers = hasErrors ? null : members;

    this.props.setMembers(actualMembers);
    this.setState({ errors });
  }

  renderErrors() {
    return this.state.errors.map(error => (
      <p key={error.line} className="error-message" style={{ color: 'red' }}>
        Line {error.line}: {error.message}
      </p>
    ));
  }

  render() {
    return (
      <tr>
        <th><label htmlFor="file">CSV File</label></th>
        <td>
          <input type="file" onChange={this.fileChanged} />
          <div className="csv-errors">
            {this.renderErrors()}
          </div>
        </td>
      </tr>
    );
  }
}

const mapStateToProps    = null;
const mapDispatchToProps = { setMembers };

export default connect(mapStateToProps, mapDispatchToProps)(CsvFileChooserUnconnected);
